import { render, staticRenderFns } from "./multiple-answer.vue?vue&type=template&id=f85bd26c&scoped=true"
import script from "./multiple-answer.ts?vue&type=script&lang=ts&external"
export * from "./multiple-answer.ts?vue&type=script&lang=ts&external"
import style0 from "./multiple-answer.scss?vue&type=style&index=0&id=f85bd26c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85bd26c",
  null
  
)

export default component.exports